<template>
  <app-layout>
    <app-layout-header></app-layout-header>
    <app-layout-body>
      <div class="page-full page-home">
        <app-page-box>
          <div class="page-home__header">
            <div class="page-home__user-info">
              <app-user-card
                :img="user.avatar | showImage"
                :username="user.username"
                :company="user.companyName"></app-user-card>
            </div>
            <div class="page-home__package">
              <div class="page-home__package-name">{{ productTypeMap[combo.productType] || '-' }}</div>
              <ul class="page-home__package-info-list">
                <li class="page-home__package-info-item">
                  <span>服务有效时长：</span>
                  <span>{{ combo.effectiveTime }} 个月</span>
                </li>
                <li class="page-home__package-info-item">
                  <span>剩余推广天数：</span>
                  <span>{{ combo.isRecommended ? combo.remainTime : '-' }} 天</span>
                </li>
                <li class="page-home__package-info-item">
                  <span>已推广天数：</span>
                  <span>{{ combo.isRecommended ? combo.costTime : '-' }} 天</span>
                </li>
              </ul>
            </div>
          </div>
        </app-page-box>
        <app-page-box title="关键词">
          <el-tooltip slot="tools" effect="dark" content="更多" placement="bottom">
            <router-link :to="{ name: 'Keyword' }">
              <app-svg-icon icon-class="more"></app-svg-icon>
            </router-link>
          </el-tooltip>
          <el-select
            v-model="chartType"
            @change="handleChartTypeChange"
            placeholder="请选择图表类型"
            size="mini"
          >
            <el-option
              v-for="item in chartTypeOptions"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
          <div class="page-home__panel">
            <div class="page-home__panel__row">
              <div class="page-home__panel__row__left">
                <app-line-chart :chart-data="keyword.chartData"></app-line-chart>
              </div>
              <div class="page-home__panel__row__right">
                <template v-if="groupKeywords.length">
                  <app-keyword-group v-for="item in groupKeywords" :title="item.label" :keywords="item.keywords" :key="item.id"></app-keyword-group>
                </template>
                <template v-else>
                  <app-no-data></app-no-data>
                </template>
              </div>
            </div>
            <div class="page-home__panel__row">
              <div class="page-home__panel__row__left">
                <app-overview-bar>
                  <app-overview-bar-item label="前5页排名量" tip="搜索引擎前5页的关键词排名数量；1个关键词在同一搜索引擎有多个排名，计算1个关键词排名量；1个关键词在多个搜索引擎有排名，计算多个排名" :value="keywordStats.fifthPageKeywordsCount"></app-overview-bar-item>
                  <app-overview-bar-item label="首页排名量" tip="搜索引擎第1页的关键词排名数量；1个关键词在同一搜索引擎有多个排名，计算1个关键词排名量；1个关键词在多个搜索引擎有排名，计算多个排名" :value="keywordStats.firstPageKeywordsCount"></app-overview-bar-item>
                </app-overview-bar>
              </div>
              <div class="page-home__panel__row__right">
                <span class="page-home__panel__tip">关键词拓展：分析师根据您所从事的行业及主营业务进行关键词拓展</span>
              </div>
            </div>
          </div>
        </app-page-box>
        <app-page-box title="流量">
          <el-tooltip slot="tools" effect="dark" content="更多" placement="bottom">
            <router-link :to="{ name: 'Traffic' }">
              <app-svg-icon icon-class="more"></app-svg-icon>
            </router-link>
          </el-tooltip>
          <div class="page-home__panel">
            <div class="page-home__panel__row">
              <div class="page-home__panel__row__left">
                <app-line-chart :chart-data="traffic.chartData"></app-line-chart>
              </div>
              <div class="page-home__panel__row__right">
                <el-tabs value="first" @tab-click="handleClick">
                  <el-tab-pane label="最新点击" name="first">
                    <app-articles v-if="article.newestHitArticle.list.length">
                      <app-articles-item
                        v-for="item in article.newestHitArticle.list"
                        format="YYYY-MM-DD"
                        :simple="true"
                        :article="item"
                        :key="item.id"/>
                    </app-articles>
                    <app-no-data v-else></app-no-data>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
            <div class="page-home__panel__row">
              <div class="page-home__panel__row__left">
                <app-overview-bar>
                  <app-overview-bar-item label="最近7天流量" tip="截止当前时间7天内产生的流量，用户每打开一个页面被记录一次，用户多次打开同一页面，浏览量值累计" :value="traffic.stats.traffic7DaysCount"></app-overview-bar-item>
                  <app-overview-bar-item label="最近30天流量" tip="截止当前时间30天内产生的流量，用户每打开一个页面被记录一次，用户多次打开同一页面，浏览量值累计" :value="traffic.stats.traffic30DaysCount"></app-overview-bar-item>
                  <app-overview-bar-item label="总流量" tip="截止当前时间账户推广产生的总流量，用户每打开一个页面被记录一次，用户多次打开同一页面，浏览量值累计" :value="traffic.stats.trafficTotalCount"></app-overview-bar-item>
                </app-overview-bar>
              </div>
              <div class="page-home__panel__row__right">
                <span class="page-home__panel__tip">关键词拓展：BI数据统计实时统计关键词的流量数据</span>
              </div>
            </div>
          </div>
        </app-page-box>
        <app-page-box title="文章发布">
          <el-tooltip slot="tools" effect="dark" content="更多" placement="bottom">
            <router-link :to="{ name: 'ArticleInfo' }">
              <app-svg-icon icon-class="more"></app-svg-icon>
            </router-link>
          </el-tooltip>
          <div class="page-home__panel">
            <div class="page-home__panel__row">
              <div class="page-home__panel__row__left">
                <app-line-chart :chart-data="article.chartData"></app-line-chart>
              </div>
              <div class="page-home__panel__row__right">
                <el-tabs value="first" @tab-click="handleClick">
                  <el-tab-pane label="最新发布" name="first">
                    <app-articles>
                      <app-articles-item
                        v-for="item in article.newestPublishArticle.list"
                        :simple="true"
                        :article="item"
                        :key="item.id"
                      ></app-articles-item>
                    </app-articles>
                  </el-tab-pane>
                  <!-- <el-tab-pane label="最新收录" name="second">
                    <app-articles>
                      <app-articles-item
                        v-for="item in article.newestIndexArticle.list"
                        :simple="true"
                        :article="item"
                        :key="item.id"
                      ></app-articles-item>
                    </app-articles>
                  </el-tab-pane> -->
                </el-tabs>
              </div>
            </div>
            <div class="page-home__panel__row">
              <div class="page-home__panel__row__left">
                <app-overview-bar>
                  <app-overview-bar-item label="智能发布量" tip="系统AI智能发布文章数量" :value="article.stats.aiPublishArticleCount"></app-overview-bar-item>
                  <app-overview-bar-item label="自主发布量" tip="客户自行发布的文章数量" :value="article.stats.publishArticleCount"></app-overview-bar-item>
                  <app-overview-bar-item label="总发布量" tip="总发布量=智能发布量+自主发布量" :value="article.stats.aiPublishArticleCount + article.stats.publishArticleCount"></app-overview-bar-item>
                </app-overview-bar>
              </div>
              <div class="page-home__panel__row__right">
                <span class="page-home__panel__tip">关键词发布：智能平台依据关键词检索量，竞争力等多维度自动匹配关键词进行发布</span>
              </div>
            </div>
          </div>
        </app-page-box>
        <app-guide></app-guide>
      </div>
    </app-layout-body>
    <app-layout-footer v-if="needFooter"></app-layout-footer>
  </app-layout>
</template>

<script>
import AppNoData from './AppNoData'
import AppGuide from '@/components/AppGuide'
import AppPageBox from '@/components/AppPageBox'
import AppUserCard from '@/components/AppUserCard'
import AppLineChart from '@/components/AppLineChart'
import AppKeywordGroup from '@/components/AppKeywordGroup'
import { AppArticles, AppArticlesItem } from '@/components/AppArticles'
import AppOverviewBar, { AppOverviewBarItem } from '@/components/AppOverviewBar'
import keywordType from '@/assets/maps/keywordType'
import { getTimestamp } from '@/utils'

export default {
  name: 'Home',
  components: {
    AppGuide,
    AppNoData,
    AppPageBox,
    AppUserCard,
    AppLineChart,
    AppArticles,
    AppArticlesItem,
    AppOverviewBar,
    AppKeywordGroup,
    AppOverviewBarItem
  },
  props: {
    needFooter: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      dateRange: [ new Date(2018, 0, 1), new Date() ],
      chartType: 1,
      chartTypeOptions: [
        { label: '首页排名量', value: 1 },
        { label: '前5页排名量', value: 5 }
      ],
      productTypeMap: {
        1: '标准版套餐',
        2: '官方版套餐'
      }
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },
    combo () {
      return this.$store.state.account.combo
    },
    keywordStats () {
      return this.$store.state.account.stats
    },
    keyword () {
      return this.$store.state.keyword
    },
    traffic () {
      return this.$store.state.traffic
    },
    article () {
      return this.$store.state.article
    },
    groupKeywords () {
      const list = this.keyword.allRecommendKeywords
      const obj = {}

      list.forEach(item => {
        if (obj[item.type]) {
          obj[item.type].keywords.push({
            id: item.id,
            keyword: item.name,
            size: item.size
          })
        } else {
          obj[item.type] = {
            id: item.type,
            label: keywordType.getLabelById(item.type),
            keywords: [{
              id: item.id,
              keyword: item.name,
              size: item.size
            }]
          }
        }
      })

      return Object.keys(obj).map(key => obj[key])
    }
  },

  created () {
    this.getComboInfo()
    this.getKeywordsChartData()
    this.getAllRecommendKeywords()
    this.getTrafficStats()
    this.getTrafficChartData()
    this.getNewsetHitArticles()
    this.getArticlesStats()
    this.getArticlesChartData()
    this.getNewsetPublishArticles()
    // this.getNewsetIndexArticles()
  },

  methods: {
    // 获取套餐信息
    getComboInfo () {
      this.$store.dispatch('getComboInfo')
    },

    getKeywordsChartData () {
      this.$store.dispatch('getKeywordsChartData', {
        query: {
          uid: this.user.id,
          page_num: this.chartType, // 1：首页, 3：前三页, 5：前5页
          start_time: getTimestamp(this.dateRange[0], 's'),
          end_time: getTimestamp(this.dateRange[1], 's')
        }
      })
    },

    getAllRecommendKeywords () {
      this.$store.dispatch('getAllRecommendKeywords', {
        params: { userId: this.user.id }
      })
    },

    getTrafficStats () {
      this.$store.dispatch('getTrafficStats', {
        params: { userId: this.user.id }
      })
    },

    getTrafficChartData () {
      this.$store.dispatch('getTrafficChartData', {
        params: { userId: this.user.id },
        query: {
          fromTime: getTimestamp(this.dateRange[0], 's'),
          toTime: getTimestamp(this.dateRange[1], 's')
        }
      })
    },

    getArticlesStats () {
      this.$store.dispatch('getArticlesStats', {
        params: { userId: this.user.id }
      })
    },

    getArticlesChartData () {
      this.$store.dispatch('getArticleChartData', {
        query: {
          uid: this.user.id,
          start_time: getTimestamp(this.dateRange[0], 's'),
          end_time: getTimestamp(this.dateRange[1], 's')
        }
      })
    },

    getNewsetHitArticles () {
      this.$store.dispatch('getNewsetHitArticles', {
        params: { userId: this.user.id },
        query: {
          order: 3,
          status: [ 5, 105 ],
          offset: 0,
          limit: 4
        }
      })
    },

    getNewsetPublishArticles () {
      this.$store.dispatch('getNewsetPublishArticles', {
        params: { userId: this.user.id },
        query: {
          order: 1,
          status: [ 5, 105 ],
          offset: 0,
          limit: 4
        }
      })
    },

    getNewsetIndexArticles () {
      this.$store.dispatch('getNewsetIndexArticles', {
        params: { userId: this.user.id },
        query: {
          order: 2,
          status: [ 5, 105 ],
          offset: 0,
          limit: 4
        }
      })
    },

    handleChartTypeChange () {
      this.getKeywordsChartData()
    },

    handleClick (tab, event) {
      console.log('[DEBUG] change tab')
    }
  }
}
</script>

<style lang="scss">
.page-home {
  position: relative;

  &__header {
    display: flex;
    align-items: center;
  }

  &__user-info {
    width: 400px;
    border-right: 1px solid #eee;
  }

  &__package {
    margin-left: 100px;

    &-name {
      color: #999;
      font-size: 16px;
    }

    &-info-list {
      padding: 0;
      margin-top: 15px;
      margin-bottom: 0;
      list-style-type: none;
    }

    &-info-item {
      display: inline-block;
      margin-right: 30px;
      span:nth-child(2) {
        font-weight: 700;
      }
    }
  }

  &__panel {
    &__row {
      display: flex;
      padding-top: 15px;
      padding-bottom: 15px;
      border-bottom: 1px solid #eee;

      &:last-child {
        border-bottom: 0;
      }

      &__left {
        width: 70%;
        padding-right: 15px;
      }

      &__right {
        width: 30%;
        padding-left: 15px;
      }
    }

    &__tip {
      display: block;
      color: #999;
      line-height: 1.5;
    }
  }
}
</style>
